import { useParams } from "react-router-dom";
import i18next from "i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Announcements } from "./Announcements";
import NotFound from "../404";
import { useEffect, useState } from "react";
import { Meta } from "../../Components/Helpers/Meta";
import "../News/News.styles.css"; // aynı görsel stilini kullan

const AnnouncementDetail = () => {
  const { link, lang } = useParams();
  const [language, setLanguage] = useState(lang || i18next.language);
  const [item, setItem] = useState(null);
  const [itemTitle, setItemTitle] = useState("");

  useEffect(() => {
    const onLangChange = (lng) => setLanguage(lng);
    i18next.on("languageChanged", onLangChange);
    return () => { i18next.off("languageChanged", onLangChange); };
  }, []);

  useEffect(() => {
    const found =
      Announcements.find((a) => a.link === link) ||
      Announcements.find((a) => a.link_tr === link);

    if (!found) {
      window.history.replaceState({ status: 404 }, "", window.location.href);
      return;
    }

    setItem(found);

    const isTR = (language === "tr");
    const title = isTR ? (found.title_tr || found.title) : (found.title || found.title_tr);
    const description = title;

    document.title = title;
    i18next.changeLanguage(isTR ? "tr" : "en");
    setItemTitle(title);

    const setOrCreateMeta = (selector, attrName, value, isProperty = false) => {
      let meta = document.querySelector(selector);
      if (meta) {
        meta.setAttribute(isProperty ? "property" : "name", attrName);
        meta.setAttribute("content", value);
      } else {
        meta = document.createElement("meta");
        meta.setAttribute(isProperty ? "property" : "name", attrName);
        meta.setAttribute("content", value);
        document.head.appendChild(meta);
      }
    };

    setOrCreateMeta('meta[name="description"]', "description", description);
    setOrCreateMeta('meta[property="og:title"]', "og:title", title, true);
    setOrCreateMeta('meta[property="og:description"]', "og:description", description, true);
    setOrCreateMeta('meta[property="og:type"]', "og:type", "article", true);
    setOrCreateMeta('meta[property="og:url"]', "og:url", window.location.href, true);
  }, [link, language]);

  if (!item) return <NotFound />;

  return (
    <>
      <Meta title={itemTitle} description={itemTitle} lang={language} />
      <Navbar />
      <div className="c-wrapper">
        <div className="c-hero">
          <div className="c-hero-background">
            <picture>
              <img className="c-hero-image" alt="" src={require("../../assets/hero/public-offering.jpg")} />
            </picture>
          </div>
        </div>
        <div className="c-container">
          <div className="c-new-page-row">
            <div className="c-new-page-col">
              <div className="c-new-page-container" style={{ textAlign: "center", marginTop: "3rem" }}>
                <div className="c-new-page-title">
                  {language === "tr" ? (item.title_tr || item.title) : (item.title || item.title_tr)}
                </div>
                <div className="c-new-page-date" style={{ marginTop: "1rem" }}>
                  {item.date}
                </div>
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: (language === "tr") ? (item.body_tr || item.body) : (item.body || item.body_tr),
                }}
                style={{ marginTop: "3rem" }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AnnouncementDetail;
